import { render, staticRenderFns } from "./solution-products.vue?vue&type=template&id=b5d310b0&scoped=true"
import script from "./solution-products.vue?vue&type=script&lang=js"
export * from "./solution-products.vue?vue&type=script&lang=js"
import style0 from "./solution-products.vue?vue&type=style&index=0&id=b5d310b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5d310b0",
  null
  
)

export default component.exports